//css-------------------
import "@/css/home/event_content.scss";
import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_lightbox.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";
import "@/css/share/components/_swiper.scss";
import "@/css/share/components/_maintitle.scss";
import "@/css/share/components/_ck_editor.scss";
import "@/css/share/components/_btn_more.scss";
import "@/css/share/components/_backtotop.scss";
import "@/css/share/components/_thesis_dec.scss";
import "@/css/share/components/_arti_hashtag_row.scss";
import "@/css/share/components/_socialbtn_row.scss";


//fontawesome
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/regular.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/brands.min.css");

//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import( /* webpackPrefetch: true */ "@/js/share/components/_backtotop");
import { subnav_show, subnav_hide, subnav_toggle, m_menu_open } from "@/js/share/components/_header";
import { init_imageloaded } from "@/js/share/components/_imageloader.js";

//npm lib 
import { createApp } from "vue/dist/vue.esm-browser.prod.js";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";


const app = createApp({
    data() {
        return {
            menu_open: false,
        };
    },
    watch: {
        menu_open: m_menu_open(this),
    },
    mounted() {
        const _this = this;

        init_imageloaded(function () {
        });
    },
    methods: {
        subnav_show,
        subnav_hide,
        subnav_toggle,
    },
}).mount("#app");
